import Vue from "vue";
import Router from "vue-router";

const Main = () => import("@/components/Main");
// const App = () => import("@/components/App");
// const Profile = () => import("@/components/User/Profile");
const Registration = () => import("@/components/Registration/registration");
const AddToHomeScreen = () => import("@/components/AddToHomeScreen/AddToHomeScreen");
const Welcome = () => import("@/components/Welcome/welcome");
const Takanon = () => import("@/components/Registration/Takanon");
const Privacy = () => import("@/components/Registration/Privacy");
// const Login = () => import("@/components/User/Login");
const PaymentPage = () => import("@/components/User/Payment");
// const PaymentFinish = () => import("@/components/User/PaymentFinish");
const Chapter = () => import("@/components/chapter/chapter-page");
const Game = () => import("@/components/Game-new/game-page");
const GrammarGame = () => import("@/components/GrammarGame/game-page");
const Dictionary = () => import("@/components/Dictionary/Dictionary");

const LeaderBoard = () => import("@/components/LeaderBoard/LeaderBoard");
const SavedWords = () => import("@/components/SavedWords/SavedWords");
const External = () => import("@/components/Lesson/external-game.vue");

const Settings = () => import("@/components/Settings/Settings");
const Video = () => import("@/components/Videos/Video");
const Eng = () => import("@/components/EngGame/allEng");

const NewLesson = () => import("@/components/Lesson/lesson.vue");
const NotFound = () => import("@/components/404.vue");
const Lesson = () => import("@/components/Lesson/lesson-page.vue");

import '../locales/main'

import AuthGuard from "./auth-guard";

Vue.use(Router);
export const Routes = [
  {
    path: "/",
    name: "",
    component: Main,
    beforeEnter: AuthGuard,
    children: [
      {
        path: "/",
        name: "home",
        component: Chapter,
        beforeEnter: AuthGuard
      },
      {
        path: "/dictionary",
        name: "dictionary",
        component: Chapter,
        beforeEnter: AuthGuard,
        props: { pageProp: "dictionary" }
      },
      {
        path: "/settings",
        name: "settings",
        component: Chapter,
        beforeEnter: AuthGuard,
        props: { pageProp: "settings" }
      },
      {
        path: "/saved-words",
        name: "saved-words",
        component: Chapter,
        beforeEnter: AuthGuard,
        props: { pageProp: "savedwords" }
      },
      {
        path: "/external-grammar",
        name: "external-grammar",
        component: Chapter,
        beforeEnter: AuthGuard,
        props: { pageProp: "grammar" }
      },
      {
        path: "/external-sentence",
        name: "external-sentence",
        component: Chapter,
        beforeEnter: AuthGuard,
        props: { pageProp: "sentence" }
      },
      {
        path: "/chapter/:id",
        name: "chapter",
        component: Chapter,
        beforeEnter: AuthGuard
      },
      {
        path: "/chapter/",
        name: "chapter-check",
        component: Chapter,
        beforeEnter: AuthGuard
      },
      {
        path: "/game/:gameid/",
        name: "game",
        component: Game,
        beforeEnter: AuthGuard
      },
      {
        path: "/grammar/:gameid/",
        name: "grammar",
        component: GrammarGame,
        beforeEnter: AuthGuard
      },
      {
        path: "/sentence/:gameid/",
        name: "sentence",
        component: Eng,
        beforeEnter: AuthGuard
      },

      {
        path: "/leader-board",
        name: "leader-board",
        component: LeaderBoard,
        beforeEnter: AuthGuard
      },
      {
        path: "/external",
        name: "external",
        component: External,
        beforeEnter: AuthGuard
      },

      {
        path: "/video",
        name: "video",
        component: Chapter,
        beforeEnter: AuthGuard,
        props: { pageProp: "videos" }
      },
      {
        path: "/eng/:id",
        name: "eng",
        component: Eng,
        beforeEnter: AuthGuard
      },
      {
        path: "/install",
        name: "Install",
        component: AddToHomeScreen,
        beforeEnter: AuthGuard
      },
      {
        path: "/lesson/:id",
        name: "lesson",
        component: NewLesson,
        beforeEnter: AuthGuard
      },
      // {
      //   path: "/signin",
      //   name: "signin",
      //   component: Signin,
      //   beforeEnter: AuthGuard
      // },
      // {
      //   path: "/login",
      //   name: "login",
      //   component: Login,
      //   beforeEnter: AuthGuard
      // },
      // {
      //   path: "/profile",
      //   name: "profile",
      //   component: Profile,
      //   beforeEnter: AuthGuard
      // },
      {
        path: "/index.html",
        name: "index",
        component: Chapter,
        beforeEnter: AuthGuard
      },

      // {
      //   path: "/video-lesson",
      //   name: "video-lesson",
      //   component: VideoLesson,
      //   beforeEnter: AuthGuard
      // },
      {
        path: "/registration",
        name: "registration",
        component: Registration,
        beforeEnter: AuthGuard
      },
      {
        path: "/welcome",
        name: "welcome",
        component: Welcome,
        beforeEnter: AuthGuard
      },
      {
        path: "/terms",
        name: "terms",
        component: Takanon,
        beforeEnter: AuthGuard
      },
      {
        path: "/privacy",
        name: "privacy",
        component: Privacy,
        beforeEnter: AuthGuard
      }
    ]
  },
  {
    path: "/payment",
    name: "payment",
    component: PaymentPage,
    beforeEnter: AuthGuard
  },
  {
    path: "/payment/:id",
    name: "paymentId",
    component: PaymentPage,
    beforeEnter: AuthGuard
  },
  // {
  //   path: "/payment_finish",
  //   name: "Payment Finish",
  //   component: PaymentFinish
  // },
  { path: "*", component: NotFound }
];
export default new Router({
  base: (localStorage.getItem("localeRoute").trim().length && localStorage.getItem("localeRoute") != "/") ? '/' + localStorage.getItem("localeRoute") : undefined,
  routes: Routes,
  mode: "history"
});



// WEBPACK FOOTER //
// ./src/router/index.js